import { render, staticRenderFns } from "./MetadataSidebar.vue?vue&type=template&id=75a35af8&scoped=true&"
import script from "./MetadataSidebar.vue?vue&type=script&lang=js&"
export * from "./MetadataSidebar.vue?vue&type=script&lang=js&"
import style0 from "./MetadataSidebar.vue?vue&type=style&index=0&id=75a35af8&scoped=true&lang=css&"
import style1 from "./MetadataSidebar.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75a35af8",
  null
  
)

export default component.exports